import { render } from "./ComponentFloatingActionButton.vue?vue&type=template&id=84dff5ea"
import script from "./ComponentFloatingActionButton.vue?vue&type=script&lang=js"
export * from "./ComponentFloatingActionButton.vue?vue&type=script&lang=js"

import "./ComponentFloatingActionButton.vue?vue&type=style&index=0&id=84dff5ea&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__